'use strict';

var _ = require('lodash');
var tooltipTemplate = _.template(require('../../../toolbar-elements/templates/grid-refresh-button-tooltip-template.html'));
var GridRefreshButtonController = function GridRefreshButtonController($scope, $filter, $q, liveDataService, constants, staticDataService) {
  var rmMomentFormat = $filter('rmMomentFormat');
  var gridPanel = $scope.gridPanelScope;
  var requiredRefreshStaticDataModes = ['seasonality-demand-mode'];
  function isNotificationAvailable() {
    return !_.isUndefined($scope.liveDataNotification) && $scope.liveDataNotification.total !== 0;
  }
  function isNoTooltipState() {
    return $scope.liveDataNotification === undefined || $scope.isDisabled();
  }
  $scope.isNotificationShown = function () {
    return gridPanel.isLiveData && isNotificationAvailable();
  };
  $scope.isDisabled = function () {
    return gridPanel.isLiveData && !isNotificationAvailable();
  };
  $scope.getLastRefreshedNotification = function () {
    return 'Last Refreshed - ' + rmMomentFormat(gridPanel.lastRefreshed, 'DATE_TIME_USER_SETTINGS');
  };
  $scope.getNotificationContent = function () {
    if (isNoTooltipState()) {
      return;
    }
    var tooltipData = _.clone($scope.liveDataNotification);
    tooltipData.lastRefresh = $scope.getLastRefreshedNotification();
    tooltipData.marketMode = gridPanel.screen === constants.MARKET_SCREEN;
    tooltipData.marketServiceMode = gridPanel.gridId === 'service-demand-analysis';
    return tooltipTemplate(tooltipData);
  };
  function shouldRefreshStaticData() {
    return _.includes(requiredRefreshStaticDataModes, gridPanel.mode);
  }
  $scope.refreshGridContent = function () {
    if (_.isFunction($scope.customRefresh)) {
      return $scope.customRefresh();
    }
    var promise = shouldRefreshStaticData() ? staticDataService.loadMarkets(true) : $q.when(true);
    return promise.then(function () {
      gridPanel.refreshGridButtonHandler();
    });
  };
  $scope.$on('grid-toolbar:liveDataNotificationsChanged', function () {
    if (!_.isUndefined(gridPanel.jqxGridSettings.source) && gridPanel.isLiveData && !_.isUndefined(gridPanel.jqxGridSettings.source.loadedData)) {
      $scope.liveDataNotification = liveDataService.prepareNotificationForToolbar(gridPanel.gridId, gridPanel.jqxGridSettings.source.loadedData);
    }
  });
  $scope.$on('grid-toolbar:liveDataNotificationsUnsubscribed', function () {
    if (gridPanel.isLiveData) {
      $scope.liveDataNotification = liveDataService.resetNotificationForToolbar();
    }
  });
};
GridRefreshButtonController.$inject = ['$scope', '$filter', '$q', 'LiveDataService', 'DataRetrieverConstantsService', 'StaticDataService'];
module.exports = GridRefreshButtonController;